module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-00.1@2x.e415a530.jpg";